export { MultiTokenCollection } from '@f8n/f8n-contracts/dist/abis/MultiTokenCollection.generated';
